<script setup>
import { colors } from '../../../tailwindTheme.config.js'
import CharacterEnlarge from '../kijk_live_qmusic_nl_default/text_animations/CharacterEnlarge.vue'
import PositiveWaveLoop1 from '../../../assets/animations/energetic_frequencies/loops/positive_wave_loop_1.json'
import AnimatedBackground from '../../AnimatedBackground.vue'
import { cdnImageUrl } from '@dpgradio/creative'
import { getChartTracks } from '../../../utils/getChartTracks.js'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const colorScheme = {
  current: {
    backgroundColor: '#fff',
    color: colors.q.cr.gray.lighter,
  },
  other: {
    backgroundColor: colors.q.cr.gray.primary,
    color: colors.q.cr.gray.darker,
  },
}

const timelinePosition = ref(null)
const timelineTitle = ref(null)
const timelineArtist = ref(null)
const imageElement = ref(null)
const trackElement = ref(null)

onMounted(() => {
  imageElement?.value?.forEach((item, index) => {
    gsapTimeline({ name: `Image${index}` }).from(item, { scale: 0.8, duration: 0.8, transformOrigin: 'center center', ease: 'bounce' }, '>')
  })

  trackElement?.value?.forEach((item, index) => {
    gsapTimeline({ name: `ChartPosition${index}` })
      .from(item, { x: -1000, duration: 0.5, ease: 'power3.Out' }, '>')
      .add(timelinePosition, '>')
      .add(timelineTitle, '>')
      .add(timelineArtist, '>')
  })
})

const tracks = computed(() => getChartTracks(props.item.enrichment.chart, 4))
const currentPosition = computed(() => props.item?.enrichment?.chart?.currentPosition)
</script>

<template>
  <div v-if="tracks" class="flex flex-col justify-center relative max-h-[90vh] my-[5vh] ml-[8vh] h-[90vh] gap-14 w-8/12 6tv:h-[80vh] 6tv:max-h-[80vh] 6tv:my-[10vh] 6tv:gap-20 6tv:w-5/12">
    <div v-for="[position, track] in Object.entries(tracks)" :key="position" class="w-full h-auto">
      <div class="flex flex-no-wrap w-full">
        <img
          ref="imageElement"
          class="object-cover w-[180px] 6tv:w-[326px] rounded-[2rem] z-20 static aspect-square scale-110 origin-center"
          :src="cdnImageUrl(track?.thumbnail || '/e/18/f5/24/1579728/geheim.png', 'w480')"
        />
        <div ref="trackElement" class="w-11/12 py-2 px-4 pl-4 rounded-r-[2rem] overflow-hidden uppercase bg-q-cr-gray-primary">
          <div class="flex items-center overflow-hidden z-20 relative gap-[1.8em] flex-no-wrap h-[180px] 6tv:h-[326px]">
            <div class="w-1/6 font-cervo content-center justify-items-center min-w-[calc(100%_/_6)] text-[5rem] 6tv:text-[10rem] text-q-cr-red-primary font-bold text-center">#{{ position }}</div>
            <div
              :class="[
                'col-span-full font-cervo font-bold  overflow-hidden content-center whitespace-nowrap text-7xl 6tv:text-9xl',
                currentPosition == position ? 'text-q-cr-red-primary' : 'text-white',
              ]"
            >
              <div class="h-16 6tv:h-32 leading-[4rem] 6tv:leading-[8rem] overflow-hidden whitespace-nowrap text-ellipsis text-[max(calc(1vw_+_1vh),_4rem)] 6tv:text-[max(calc(1vw_+_1vh),_8rem)]">
                <CharacterEnlarge :text="track?.artist?.name || ''" @timeline="timelineTitle = $event" />
              </div>
              <div class="overflow-hidden font-light whitespace-nowrap">
                <CharacterEnlarge :text="track?.title || ''" @timeline="timelineArtist = $event" />
              </div>
            </div>
          </div>
          <AnimatedBackground
            :key="position + (currentPosition == position).toString()"
            :scale="4.8"
            :position="{ y: 140 }"
            :lottie="PositiveWaveLoop1"
            class="z-10"
            renderer="svg"
            :backgroundColor="currentPosition == position ? colorScheme.current.backgroundColor : colorScheme.other.backgroundColor"
            :color="currentPosition == position ? colorScheme.current.color : colorScheme.other.color"
          />
        </div>
      </div>
    </div>
  </div>
</template>
